import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '../../../../../node_modules/@angular/forms';
import { CustomValidators } from '../../../lib/customer-validators';
import { PracticeService } from '../../../services/practice.service';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-add-member-to-practice',
  templateUrl: './add-member-to-practice.component.html',
  styleUrls: ['./add-member-to-practice.component.scss']
})
export class AddMemberToPracticeComponent implements OnInit {
  public memberForm: FormGroup;
  public inviteError = null;
  public showExtra:boolean=false;
  public roles=[];

  constructor(public dialogRef: MatDialogRef<AddMemberToPracticeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any, private practiceService: PracticeService, private accountService: AccountService) {
      this.memberForm = new FormGroup({
        'email': new FormControl(null, [Validators.required, CustomValidators.validateEmailAddress]),
        'first_name': new FormControl(null),
        'last_name': new FormControl(null),
        'role': new FormControl(null)
      });
    }

  ngOnInit() {
    this.getUserRoles();
    this.memberForm.controls['role'].setValue('');
  }

  getUserRoles(){
    this.accountService.getRoles().subscribe(
      res=>{
        this.roles=res;
      }
    );
  }

  cancel(){
    this.dialogRef.close(false);
  }

  register(){
    this.inviteError=null;
    if(!this.memberForm.get('email').value){
      return this.inviteError='Please provide an Email';
    }
    if(!this.memberForm.get('first_name').value){
      return this.inviteError='Please provide a First Name';
    }
    if(!this.memberForm.get('last_name').value){
      return this.inviteError='Please provide a Last Name';
    }
    if(this.memberForm.get('role').value==''){
      return this.inviteError='Please provide a Job Role';
    }
    this.inviteError=null;
    this.practiceService.registerInviteMember(
      this.memberForm.get('email').value,
      this.memberForm.get('first_name').value,
      this.memberForm.get('last_name').value,
      this.memberForm.get('role').value
    ).subscribe(res=>{
      this.dialogRef.close(true);
    });
  }

  submit(){
    this.inviteError = null;
    this.practiceService.inviteMember(this.memberForm.get('email').value).subscribe(res=>{
      if (res.extra) {
        this.showExtra=true;
        this.inviteError = res.message;
      } else {
        this.dialogRef.close(true);
      }
    },err=>{
      this.inviteError = err.error.message;
    })
  }

}
